/** Predugovorne informacije – Alicante listopad 2026 (HR / EN / DE / ES) */

export const alicanteListopadPreContract = {
  hr: {
    title: "Predugovorne informacije",
    content: `a1.1. Odredište/odredišta: Alicante, Costa Blanca

a1.2. Plan putovanja: Odlazak zrakoplovom Ryanair iz Zagreba u Alicante 01.10.2026. direktan jutarnji let, dolazak u Alicante i transfer do privatnih, moderno opremljenih apartmana u blizini centra grada. Popodne upoznavanje s gradom: Explanada de España, luka, marina, plaža Postiguet. Drugi dan: doručak churros i topla čokolada, posjet dvorcu Santa Bárbara s mogućnošću degustacije vina, popodne radionica pripreme tradicionalne španjolske paelle. Treći dan: Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Arheološki muzej). Četvrti dan: transfer u ranim jutarnjim satima, direktan let za Zagreb.

a1.3. Razdoblja boravka s datumima: 01.10.2026. do 04.10.2026.

a1.4. Broj uključenih noćenja: 4 dana (3 noći)

a2.1. Sredstva prijevoza: avion Ryanair Zagreb–Alicante–Zagreb

a2.3. Kategorije prijevoza: direktni letovi Ryanair

a2.4. Mjesto polaska i povratka: Zračna luka Franjo Tuđman, Zagreb; Zračna luka Alicante

a2.5. Datum polaska i povratka: 01.10.2026. do 04.10.2026.

a2.6. Vrijeme polaska i povratka: informacija koju ćemo poslati prije puta

a3.1. Lokacija smještaja: privatni apartmani u blizini centra grada Alicantea

a3.2. Glavne karakteristike smještaja: apartmani, moderno opremljeni

a3.3. Vrsta smještaja u skladu s pravilima odredišne zemlje:

a3.4. Kategorija smještaja u skladu s pravilima odredišne zemlje:

a4. Plan prehrane: doručak nije uključen; ručkovi i večere u vlastitom aranžmanu

a5.1. Posjeti uključeni u ukupnu cijenu dogovorenu za paket-aranžman: organizirana šetnja gradom i glavne znamenitosti, dvorac Santa Bárbara (s mogućnošću degustacije vina), radionica pripreme paelle, Mercado Central, Barrio Santa Cruz, MARQ.

a5.2. Izlet/izleti uključeni u ukupnu cijenu dogovorenu za paket-aranžman: radionica paelle, posjet dvorcu Santa Bárbara, organizirana šetnja gradom. Izlet na otok Tabarca nije uključen (moguć uz doplatu).

a6.1. Informacija o tome pruža li se putniku neka od usluga putovanja u okviru grupe: transfer aerodrom–smještaj–aerodrom

a6.2. Informacija o približnoj veličini grupe: minimalno 8 osoba za ostvarenje putovanja

b1. Tvrtka organizatora: TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA, VL. LINA SKENDER, CESARICA, PRIMORSKA 1

b2. Zemljopisna adresa organizatora: Primorska 1, Cesarica

b3. Telefonski broj organizatora: +385 91 214 4477

b4. Prema potrebi adresa e-pošte organizatora: info@linatravelina.eu

c1. Ukupna cijena paket-aranžmana uključujući poreze: 690,00 € po osobi za rezervacije do 01.08.2026.; 790,00 € po osobi od 01.08.2026.

c2. Naznaka vrste dodatnih troškova koje će putnik možda morati snositi: carry-on prtljaga (mogućnost nadoplate za mali kofer u kabini), putno zdravstveno osiguranje i osiguranje od otkaza (moguće uz nadoplatu), ručkovi i večere, dodatne aktivnosti (npr. izlet na Tabarcu, muzeji, Flamenco)

e1. Najmanji broj osoba potreban za ostvarivanje paket-aranžmana: 8

f1. Opće informacije o uvjetima odredišne zemlje u vezi s putovnicama i vizama: nema potrebe za vizom

f3. Informacije o zdravstvenim formalnostima odredišne zemlje

f4. U cijenu nije uključeno osiguranje, te po zahtjevu putnika ćemo ponuditi odgovarajuće osiguranje.

Napomena: raspored programa po danima promjenjiv je do 2 tjedna prije puta.`,
  },
  en: {
    title: "Pre-contract Information",
    content: `a1.1. Destination(s): Alicante, Costa Blanca

a1.2. Travel plan: Departure by Ryanair from Zagreb to Alicante on 1 October 2026, direct morning flight, arrival in Alicante and transfer to private, modern apartments near the city centre. Afternoon introduction to the city: Explanada de España, port, marina, Postiguet beach. Day two: breakfast with churros and hot chocolate, visit to Santa Bárbara Castle with optional wine tasting, afternoon traditional Spanish paella workshop. Day three: Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Archaeological Museum). Day four: early morning transfer, direct flight to Zagreb.

a1.3. Periods of stay with dates: 1 October 2026 to 4 October 2026

a1.4. Number of included nights: 4 days (3 nights)

a2.1. Means of transport: Ryanair plane Zagreb–Alicante–Zagreb

a2.3. Categories of transport: Ryanair direct flights

a2.4. Place of departure and return: Franjo Tuđman Airport, Zagreb; Alicante Airport

a2.5. Date of departure and return: 1 October 2026 to 4 October 2026

a2.6. Time of departure and return: information we will send before the trip

a3.1. Accommodation location: private apartments near the centre of Alicante

a3.2. Main characteristics of accommodation: apartments, modernly equipped

a3.3. Type of accommodation in accordance with the rules of the destination country:

a3.4. Category of accommodation in accordance with the rules of the destination country:

a4. Meal plan: breakfast not included; lunches and dinners at own arrangement

a5.1. Visits included in the total price agreed for the package arrangement: organised city walk and main sights, Santa Bárbara Castle (with optional wine tasting), paella preparation workshop, Mercado Central, Barrio Santa Cruz, MARQ.

a5.2. Excursion(s) included in the total price agreed for the package arrangement: paella workshop, visit to Santa Bárbara Castle, organised city walk. Trip to Tabarca Island not included (optional supplement).

a6.1. Information about whether any travel services are provided to the traveler within a group: airport–accommodation–airport transfer

a6.2. Information about approximate group size: minimum 8 people for the trip to take place

b1. Organizer company: TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA, VL. LINA SKENDER, CESARICA, PRIMORSKA 1

b2. Geographic address of organizer: Primorska 1, Cesarica

b3. Organizer phone number: +385 91 214 4477

b4. If necessary, organizer email address: info@linatravelina.eu

c1. Total price of package arrangement including taxes: €690.00 per person for bookings until 1 August 2026; €790.00 per person from 1 August 2026

c2. Indication of the type of additional costs that the traveler may have to bear: carry-on luggage (supplement for cabin bag), travel and cancellation insurance (available at extra cost), lunches and dinners, additional activities (e.g. trip to Tabarca, museums, flamenco)

e1. Minimum number of people required for the package arrangement: 8

f1. General information about the conditions of the destination country regarding passports and visas: no visa required

f3. Information on health formalities of the destination country

f4. Insurance is not included in the price, and upon traveler's request we will offer appropriate insurance.

Note: daily schedule may change up to 2 weeks before departure.`,
  },
  de: {
    title: "Vorvertragliche Informationen",
    content: `a1.1. Reiseziel(e): Alicante, Costa Blanca

a1.2. Reiseplan: Abflug mit Ryanair von Zagreb nach Alicante am 1. Oktober 2026, direkter Morgenflug, Ankunft in Alicante und Transfer zu privaten, modernen Apartments nahe dem Stadtzentrum. Nachmittags Stadtführung: Explanada de España, Hafen, Marina, Strand Postiguet. Tag zwei: Frühstück mit Churros und heißer Schokolade, Besuch der Burg Santa Bárbara mit optionaler Weinverkostung, nachmittags Paella-Workshop. Tag drei: Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Archäologisches Museum). Tag vier: frühmorgendlicher Transfer, Direktflug nach Zagreb.

a1.3. Aufenthaltszeiträume mit Daten: 1. Oktober 2026 bis 4. Oktober 2026

a1.4. Anzahl der inbegriffenen Übernachtungen: 4 Tage (3 Nächte)

a2.1. Beförderungsmittel: Ryanair-Flugzeug Zagreb–Alicante–Zagreb

a2.3. Beförderungskategorien: Ryanair-Direktflüge

a2.4. Ort der Abreise und Rückkehr: Flughafen Franjo Tuđman, Zagreb; Flughafen Alicante

a2.5. Datum der Abreise und Rückkehr: 1. Oktober 2026 bis 4. Oktober 2026

a2.6. Uhrzeit der Abreise und Rückkehr: Information vor der Reise

a3.1. Unterkunftsort: private Apartments nahe dem Zentrum von Alicante

a3.2. Hauptmerkmale der Unterkunft: Apartments, modern ausgestattet

a3.3. Art der Unterkunft gemäß den Regeln des Ziellands:

a3.4. Kategorie der Unterkunft gemäß den Regeln des Ziellands:

a4. Verpflegungsplan: Frühstück nicht inbegriffen; Mittag- und Abendessen eigenständig

a5.1. Im Gesamtpreis enthaltene Besuche: Stadtführung, Burg Santa Bárbara (optionale Weinverkostung), Paella-Workshop, Mercado Central, Barrio Santa Cruz, MARQ.

a5.2. Im Gesamtpreis enthaltene Ausflüge: Paella-Workshop, Santa Bárbara, Stadtführung. Ausflug nach Tabarca nicht enthalten (optional).

a6.1. Gruppenservices: Transfer Flughafen–Unterkunft–Flughafen

a6.2. Ungefähre Gruppengröße: mindestens 8 Personen

b1. Organisatorfirma: TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA, VL. LINA SKENDER, CESARICA, PRIMORSKA 1

b2. Geografische Adresse des Organisators: Primorska 1, Cesarica

b3. Telefonnummer des Organisators: +385 91 214 4477

b4. E-Mail-Adresse des Organisators: info@linatravelina.eu

c1. Gesamtpreis inkl. Steuern: 690,00 € pro Person bei Buchung bis 1. August 2026; 790,00 € pro Person ab 1. August 2026

c2. Zusätzliche Kosten: Carry-on gegen Aufpreis, Reise-/Stornoversicherung optional, Mahlzeiten, Zusatzaktivitäten (z. B. Tabarca)

e1. Mindestteilnehmerzahl: 8

f1. Visum: nicht erforderlich

f3. Gesundheitsformalitäten des Ziellands

f4. Versicherung nicht im Preis inbegriffen; auf Anfrage vermittelbar.

Hinweis: Tagesablauf kann bis 2 Wochen vor Abreise angepasst werden.`,
  },
  es: {
    title: "Información precontractual",
    content: `a1.1. Destino(s): Alicante, Costa Blanca

a1.2. Plan de viaje: Salida en avión Ryanair de Zagreb a Alicante el 1 de octubre de 2026, vuelo matutino directo, llegada a Alicante y traslado a apartamentos privados modernos cerca del centro. Tarde de presentación de la ciudad: Explanada de España, puerto, marina, playa del Postiguet. Día dos: desayuno de churros y chocolate caliente, visita al castillo de Santa Bárbara con cata de vinos opcional, taller de paella por la tarde. Día tres: Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Museo Arqueológico). Día cuatro: traslado temprano, vuelo directo a Zagreb.

a1.3. Periodos de estancia con fechas: del 1 al 4 de octubre de 2026

a1.4. Número de noches incluidas: 4 días (3 noches)

a2.1. Medios de transporte: avión Ryanair Zagreb–Alicante–Zagreb

a2.3. Categorías de transporte: vuelos directos Ryanair

a2.4. Lugar de salida y regreso: aeropuerto Franjo Tuđman, Zagreb; aeropuerto de Alicante

a2.5. Fecha de salida y regreso: del 1 al 4 de octubre de 2026

a2.6. Hora de salida y regreso: información antes del viaje

a3.1. Ubicación del alojamiento: apartamentos privados cerca del centro de Alicante

a3.2. Características principales del alojamiento: apartamentos modernos

a3.3. Tipo de alojamiento según las normas del país de destino:

a3.4. Categoría de alojamiento según las normas del país de destino:

a4. Plan de comidas: desayuno no incluido; comidas por cuenta propia

a5.1. Visitas incluidas en el precio total: paseo guiado, castillo de Santa Bárbara (cata opcional), taller de paella, Mercado Central, Barrio Santa Cruz, MARQ.

a5.2. Excursiones incluidas: taller de paella, Santa Bárbara, paseo guiado. Excursión a Tabarca no incluida (suplemento opcional).

a6.1. Servicios en grupo: traslado aeropuerto–alojamiento–aeropuerto

a6.2. Tamaño aproximado del grupo: mínimo 8 personas

b1. Empresa organizadora: TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA, VL. LINA SKENDER, CESARICA, PRIMORSKA 1

b2. Dirección geográfica del organizador: Primorska 1, Cesarica

b3. Teléfono del organizador: +385 91 214 4477

b4. Correo electrónico del organizador: info@linatravelina.eu

c1. Precio total del paquete incl. impuestos: 690,00 € por persona reservando hasta el 1 de agosto de 2026; 790,00 € por persona desde el 1 de agosto de 2026

c2. Costes adicionales posibles: equipaje de cabina con suplemento, seguros opcionales, comidas, actividades extra (p. ej. Tabarca)

e1. Número mínimo de personas: 8

f1. Visado: no necesario

f3. Formalidades sanitarias del país de destino

f4. Seguro no incluido; disponible bajo petición.

Nota: el programa diario puede cambiar hasta 2 semanas antes de la salida.`,
  },
};
